import { render, staticRenderFns } from "./FaqViewInfo.vue?vue&type=template&id=6a753ba3&"
import script from "./FaqViewInfo.vue?vue&type=script&lang=js&"
export * from "./FaqViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports